/* Sale Reservation Card page (sections/ls-rc-sale-product.liquid): tier picker (card, price, facts and the
 * variant in the form follow the pick, ?variant= or ?rc= opens on a tier), the sale window (the button only
 * adds between data-from and data-to on the sale's clock) and AJAX add to cart into Minimog's drawer. */
(() => {
  const at = (v, off) => {
    const m = /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/.exec(String(v || '').trim());
    return m ? Date.UTC(+m[1], m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0)) - off : null;
  };

  const init = (root) => {
    if (root.dataset.lrcSaleReady) return;
    root.dataset.lrcSaleReady = '1';
    const d = root.dataset;
    const picks = [...root.querySelectorAll('.lrc-sale__pick')];
    const form = root.querySelector('[data-lrc-sale-form]');
    const idIn = form?.querySelector('[data-lrc-sale-id]');
    const btn = form?.querySelector('[data-lrc-sale-submit]');
    const label = form?.querySelector('[data-lrc-sale-label]');
    const error = form?.querySelector('[data-lrc-sale-error]');
    const agree = form?.querySelector('[data-lrc-sale-agree]');
    const agreeText = form?.querySelector('[data-lrc-sale-agree-text]');
    const price = root.querySelector('[data-lrc-price]');
    const z = /^([+-])(\d{1,2}):?(\d{2})?/.exec(d.tz || '+08:00');
    const off = z ? (z[1] === '-' ? -1 : 1) * (+z[2] * 60 + +(z[3] || 0)) * 60000 : 0;
    const from = at(d.from, off);
    const to = at(d.to, off);
    let busy = false;

    const phase = () => {
      const now = Date.now();
      if (from && now < from) return 'upcoming';
      if (to && now >= to) return 'ended';
      return 'live';
    };
    const current = () => picks.find((b) => b.getAttribute('aria-checked') === 'true');
    const sync = () => {
      if (!btn) return;
      const b = current();
      const ph = phase();
      const avail = b ? b.dataset.available === '1' : !btn.hasAttribute('data-off');
      let text = b?.dataset.label || label.textContent;
      if (ph === 'upcoming') text = d.upcoming || text;
      else if (ph === 'ended') text = d.ended || text;
      else if (!avail) text = d.soldout || text;
      if (busy) text = d.adding || text;
      label.textContent = text;
      btn.disabled = busy || ph !== 'live' || !avail || (agree ? !agree.checked : false);
      btn.setAttribute('aria-busy', busy ? 'true' : 'false');
      if (agreeText && b?.dataset.label) agreeText.textContent = agreeText.dataset.tpl.replace('[button]', b.dataset.label);
    };
    const pick = (b, focus, push) => {
      if (!b) return;
      root.dataset.pick = b.dataset.pick;
      picks.forEach((x) => { x.setAttribute('aria-checked', String(x === b)); x.tabIndex = x === b ? 0 : -1; });
      if (b.dataset.variant && idIn) idIn.value = b.dataset.variant;
      /* the theme's money format, as the server printed it (currency apps hook its span) */
      if (b.dataset.price && price) price.innerHTML = b.dataset.price;
      if (focus) b.focus();
      if (push && b.dataset.variant) {
        const u = new URL(location.href);
        u.searchParams.set('variant', b.dataset.variant);
        u.searchParams.delete('rc');
        history.replaceState(history.state, '', u);
      }
      sync();
    };
    picks.forEach((b, i) => {
      b.addEventListener('click', () => pick(b, false, true));
      b.addEventListener('keydown', (e) => {
        const step = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        pick(picks[(i + step + picks.length) % picks.length], true, true);
      });
    });
    const q = new URLSearchParams(location.search);
    pick(picks.find((b) => b.dataset.pick === q.get('rc')) || current() || picks[0], false, false);
    agree?.addEventListener('change', sync);
    setInterval(() => { if (!busy) sync(); }, 15000);

    form?.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (busy || btn.disabled) return;
      busy = true;
      if (error) { error.hidden = true; error.textContent = ''; }
      sync();
      const drawer = document.querySelector('m-cart-drawer');
      const useDrawer = drawer && window.MinimogSettings?.enable_cart_drawer && typeof drawer.renderContents === 'function';
      const body = new FormData(form);
      if (useDrawer) {
        body.append('sections', drawer.getSectionsToRender().map((s) => s.id));
        body.append('sections_url', location.pathname);
      }
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body,
        });
        const out = await res.json();
        if (!res.ok || out.status) {
          if (error) { error.textContent = out.description || out.message || d.error; error.hidden = false; }
          return;
        }
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: out } }));
        if (useDrawer) {
          drawer.renderContents(out);
          drawer.getCart?.().then((cart) => cart && drawer.updateCartCount(cart.item_count));
        } else location.href = (window.Shopify?.routes?.root || '/') + 'cart';
      } catch (err) {
        if (error) { error.textContent = d.error; error.hidden = false; }
      } finally {
        busy = false;
        sync();
      }
    });
  };

  const start = () => document.querySelectorAll('[data-lrc-sale]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
